import React, {useState, useMemo} from 'react';
import {useNavigate} from 'react-router';
import {useSnackbar} from 'notistack';
import {Container, Stack, Typography} from '@mui/material';
import withMainContainer from '../components/WithMainContainer.js';
import SCTextField from '../components/SCTextField.js';
import SCButton from '../components/SCButton.js';
import {useBusyCallback, useQueryParam} from '../util/react_hooks.js';
import api from '../util/api.js';

const PasswordReset = ()=>{
    let [error, setError] = useState();
    let [password, setPassword] = useState('');
    let [repeatPassword, setRepeatPassword] = useState('');
    let {enqueueSnackbar} = useSnackbar();
    let navigate = useNavigate();
    let [tokenData] = useQueryParam('token');
    let [userId, token] = useMemo(()=>tokenData?.split('-')||[], [tokenData]);
    let [onConfirm, confirming] = useBusyCallback(async ()=>{
        setError();
        try {
            await api.passwordResetConfirm({userId, token, password, repeatPassword});
            enqueueSnackbar('הסיסמא אופסה בהצלחה! ניתן להתחבר כרגיל', {variant: 'success'});
            navigate('/');
        } catch (e) {
            if (e.code=='unauthorized')
                return void setError('אין גישה. יכול להיות שפג תוקף הקישור. נא לבקש איפוס סיסמא מחדש.');
            if (e.code=='validation_error')
                return void setError(<>{e.extra.map(c=>c.message).filter(Boolean).join(<br/>)}</>);
            setError('אירעה שגיאה, נסו שוב מאוחר יותר');
        }
    }, [userId, token, password, repeatPassword, enqueueSnackbar, navigate]);
    return <Container maxWidth="sm">
      <Stack direction="column" gap={2} justifyContent="center" alignItems="center">
        <Typography variant="h4">איפוס סיסמא</Typography>
        <SCTextField required label="סיסמא" type="password" variant="outlined" value={password} onChange={setPassword}/>
        <SCTextField required label="אימות סיסמא" type="password" variant="outlined" value={repeatPassword} onChange={setRepeatPassword}/>
        <SCButton text="איפוס" variant="contained" onClick={onConfirm} loading={confirming}
          size="large"/>
        {error&&<Typography color="red">{error}</Typography>}
      </Stack>
    </Container>
};

export default withMainContainer(PasswordReset, {footerMargin: 8});
